import { useState } from 'react';
import { SidebarLayout } from '@/layouts/SidebarLayout';
import { Button } from '@/components/ui/button';
import { DuplicatesList } from '@/components/duplicates/DuplicatesList';
import { MergeHistory } from '@/components/duplicates/MergeHistory';
import { useWorkspaces } from '@/hooks/useWorkspaces';
import { Users, History } from 'lucide-react';
import { cn } from '@/lib/utils';

export function DuplicatesPage() {
  const [activeView, setActiveView] = useState<'duplicates' | 'history'>('duplicates');
  const { currentWorkspace } = useWorkspaces();

  const Sidebar = (
    <div className="space-y-6 pt-4">
      <div className="px-4">
        <h2 className="font-semibold text-lg">Duplicates</h2>
        <p className="text-xs text-muted-foreground mt-1">Identify and merge duplicate contacts</p>
      </div>
      <nav className="space-y-1 px-2">
        <Button
          variant="ghost"
          className={cn(
            "w-full justify-start gap-2",
            activeView === 'duplicates' && "bg-accent"
          )}
          onClick={() => setActiveView('duplicates')}
        >
          <Users className="h-4 w-4" />
          Potential Duplicates
        </Button>
        <Button
          variant="ghost"
          className={cn(
            "w-full justify-start gap-2",
            activeView === 'history' && "bg-accent"
          )}
          onClick={() => setActiveView('history')}
        >
          <History className="h-4 w-4" />
          Merge History
        </Button>
      </nav>
    </div>
  );

  if (!currentWorkspace) {
    return (
      <SidebarLayout sidebar={Sidebar}>
        <div className="h-full p-6">
          <div className="text-center py-8 text-muted-foreground">
            No workspace selected
          </div>
        </div>
      </SidebarLayout>
    );
  }

  return (
    <SidebarLayout sidebar={Sidebar}>
      <div className="h-full p-6">
        {activeView === 'duplicates' ? (
          <DuplicatesList workspaceId={currentWorkspace.id} />
        ) : (
          <MergeHistory workspaceId={currentWorkspace.id} />
        )}
      </div>
    </SidebarLayout>
  );
}
